export default __webpack_public_path__ + "static/media/bajaj.52110713.jpg";